import { Typography, styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';
import { useNavigate } from 'react-router-dom';
import FidoLogo from 'src/frontend-common/components/Logo';
import ButtonComponent from 'src/components/ButtonComponent';
import PasswordUpdated from 'src/frontend-common/components/Icons/PasswordUpdated';

const Container = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(5),
  width: '100%',
  alignSelf: 'center',
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1002.5px',
    padding: theme.spacing(15),
  },
}));

const Spacer = styled(Column)(({ theme }) => ({
  marginBottom: theme.spacing(5),
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  lineHeight: 1.2,
  color: theme.palette.primary.main,
  marginBottom: 20,
  textAlign: 'center',
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.1,
  color: theme.palette.text.primary,
  textAlign: 'center',
}));

const CustomButton = styled(ButtonComponent)(({ theme }) => ({
  height: 56,
  width: '100%',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(5),
  },
}));

export const ForgotPasswordCodeSentPage = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <div style={{ marginBottom: 95 }}>
        <FidoLogo />
      </div>
      <div>
        <div style={{ marginBottom: 24 }}>
          <PasswordUpdated />
        </div>

        <Spacer centered>
          <Title style={{ fontSize: 40, fontWeight: 600, color: 'black' }}>Password updated!</Title>
          <Subtitle>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 400,
                color: '#616161',
                marginBottom: 24,
              }}
            >
              Your password has been successfully changed. You may proceed to login.
            </Typography>
          </Subtitle>
        </Spacer>

        <Column centered>
          <CustomButton
            buttontype="mainaction"
            style={{ backgroundColor: 'black' }}
            disableElevation={true}
            onClick={() => navigate('/login')}
            text="Sign in"
          />
        </Column>
      </div>
    </Container>
  );
};
